export const spacing0 = '4px';
export const spacing1 = '8px';
export const spacing2 = '16px';
export const spacing3 = '24px';
export const spacing4 = '32px';
export const spacing5 = '40px';
export const spacing6 = '48px';
export const spacing7 = '56px';
export const spacing8 = '64px';
export const spacing9 = '72px';
export const spacing10 = '80px';
export const spacing11 = '88px';
export const spacing13 = '104px';
export const spacing18 = '144px';
